import { Component, OnDestroy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Chart } from "chart.js";
import { BrandCampaign } from "../../../shared/models/brandCampaign";

import {
  BrandCampaignInsight,
  BrandCampaignInsightChart,
} from "../../../shared/models/brandCampaignInsight";
import { NotificationService } from "../../../shared/services/notification.service";
import { BrandCampaignInsightService } from "../shared/services/brand-campaign-insight.service";
import { BrandCampaignService } from "../shared/services/brand-campaign.service";

@Component({
  selector: "app-brand-campaign-dashboard",
  templateUrl: "./brand-campaign-dashboard.component.html",
  styleUrl: "./brand-campaign-dashboard.component.scss",
})
export class BrandCampaignDashboardComponent implements OnDestroy {
  protected campaign: BrandCampaign;
  protected loadingStatsData = true;
  protected loadingLinearChartsData = true;
  protected insights?: BrandCampaignInsight;
  protected insightCharts?: BrandCampaignInsightChart;

  constructor(
    private readonly brandCampaignInsightService: BrandCampaignInsightService,
    private readonly brandCampaignService: BrandCampaignService,
    private readonly notificationService: NotificationService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    this.campaign = this.brandCampaignService.currentBrandCampaign;
    this.initData();
  }

  private initData(): void {
    this.getBrandCampaignInsights();
    this.getBrandCampaignInsightCharts();
  }

  private async getBrandCampaignInsights(): Promise<void> {
    const getBrandCampaignInsightsResult =
      this.brandCampaignInsightService.getBrandCampaignInsights(
        this.campaign.id,
      );
    try {
      this.insights = await getBrandCampaignInsightsResult;
    } catch (error) {
      this.notificationService.error("shared.errorLoadingTheCampaign");
    }

    this.loadingStatsData = false;
  }

  private async getBrandCampaignInsightCharts(): Promise<void> {
    const getBrandCampaignInsights =
      this.brandCampaignInsightService.getBrandCampaignInsightsCharts(
        this.campaign.id,
      );
    this.insightCharts = await getBrandCampaignInsights;
    this.loadingLinearChartsData = false;
  }

  public showNewCharts(): boolean {
    if (this.insights) {
      return this.insights.showDailyCharts;
    }
    return false;
  }

  public ngOnDestroy(): void {
    for (const chartIndex of Object.keys(Chart.instances)) {
      Chart.instances[chartIndex].destroy();
    }
  }
}
